export var base = '_2whln';
export var sizes = {base:'_2pAPz',small:'_3Y-yY'};
export var variants = {red:'$A9UPD',white:'$MoVbR'};